import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';

import {
  API_TASK_STEP_DELETE_SAS,
  API_TASK_STEP_DOWNLOAD_SAS,
  API_TASK_STEP_SUBMIT,
  API_TASK_STEP_UPLOAD_SAS
} from '../../../../config/urls';
import {UrlService} from '@shared/services/url.service';
import {TaskStepUpdateDto} from '@dto/tasks/task-step-update.dto';
import {FlowAttachmentDownloadSasRequestDto, FlowAttachmentSasRequestDto} from '@dto/files/flow-attachment-sas-request.dto';
import {FlowAttachmentSasResponseDto} from '@dto/files/flow-attachment-sas-response.dto';

@Injectable({providedIn: 'root'})
export class FileTaskService {

  private readonly http = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public submitStep(taskId: string, taskStepId: number): Observable<TaskStepUpdateDto> {
    const endpointUrl = this.urlService.buildUrl(API_TASK_STEP_SUBMIT, taskId, String(taskStepId));
    return this.http.post<TaskStepUpdateDto>(endpointUrl, {});
  }

  public requestUploadSas(
    taskId: string,
    taskStepId: number,
    payload: FlowAttachmentSasRequestDto
  ): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_TASK_STEP_UPLOAD_SAS, taskId, String(taskStepId));
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, payload);
  }

  public requestDeleteSas(
    taskId: string,
    taskStepId: number,
    payload: FlowAttachmentSasRequestDto
  ): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_TASK_STEP_DELETE_SAS, taskId, String(taskStepId));
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, payload);
  }

  public requestDownloadSas(
    taskId: string,
    taskStepId: number,
    payload: FlowAttachmentDownloadSasRequestDto
  ): Observable<FlowAttachmentSasResponseDto> {
    const endpointUrl = this.urlService.buildUrl(API_TASK_STEP_DOWNLOAD_SAS, taskId, String(taskStepId));
    return this.http.post<FlowAttachmentSasResponseDto>(endpointUrl, payload);
  }

}
